import { createRequest } from "../../../../utils/request/createRequest";

export const request = createRequest({
    baseURL: '/scripts',
    headers: { 'content-type': 'multipart/form-data' }
});
